export const INV_LIST_REQ_BEGIN_DATE = '01-01-1900';
export const INV_LIST_REQ_END_DATE = '01-01-9999';
export const SUCCESS = 'Success';
